<template>
    <div id="app" class="wrapper">
        <router-view></router-view>
    </div>
</template>
<script>
export default {
    name: 'App',
    mounted() {
        document.body.className += 'skin-gradient sidebar-mini';
    },
};
</script>
<style lang="scss">
@import 'sass/main';
</style>



// WEBPACK FOOTER //
// App.vue?50747c92